import React from 'react';
import { useBargain } from 'app/BargainWidget/context/BargainContext';
import { darkenHexColor } from 'app/BargainWidget/Bargains/utils/common-utils';

const BargainAuthV1 = () => {
  const { translation, widgetSettings } = useBargain();
  const redirectToSignIn = () => {
    location.href = `${window?.['Shopify']?.routes?.root || '/'}account/login?return_url=${location.pathname}`;
  };

  const redirectToSignUp = () => {
    location.href = `${window?.['Shopify']?.routes?.root || '/'}account/register?return_url=${location.pathname}`;
  };

  return (
    <div className="se-text-center se-py-6 se-px-4 bargain-widget-v1-auth">
      <h3 className="se-text-lg se-font-semibold se-text-gray-900 se-mb-2 bargain-widget-v1-auth-label">{translation?.loginTitle || 'Sign in to make an offer'}</h3>
      <p className="se-text-sm se-text-gray-500 se-mb-6 bargain-widget-v1-auth-description">
        {translation?.loginContent || 'To make an offer, please log in or sign up for a free account'}
      </p>
      <div className="se-flex se-flex-wrap se-gap-2 se-justify-center bargain-widget-v1-auth-actions">
        <button
          onClick={redirectToSignUp}
          style={
            {
              '--offer-button-background-color': widgetSettings?.offerButtonBackgroundColor || '#000000',
              '--offer-button-hover-background-color': darkenHexColor(widgetSettings?.offerButtonBackgroundColor || '#000000', 3),
              '--offer-button-text-color': widgetSettings?.offerButtonTextColor || '#ffffff',
            } as any
          }
          className="se-w-full se-px-6 se-py-2 se-rounded-md se-bg-[var(--offer-button-background-color)] hover:se-bg-[var(--offer-button-hover-background-color)] se-text-[var(--offer-button-text-color)] se-font-medium se-transition-colors bargain-widget-v1-auth-signup-button"
        >
          {translation?.creatAccount || 'Create Account'}
        </button>
        <button
          onClick={redirectToSignIn}
          className="se-w-full se-px-6 se-py-2 se-rounded-md se-bg-gray-100 se-text-gray-700 se-font-medium hover:se-bg-gray-200 se-transition-colors  bargain-widget-v1-auth-login-button"
        >
          {translation?.signIn || 'Sign In'}
        </button>
      </div>
    </div>
  );
};

export default BargainAuthV1;
